import { useTranslation } from "react-i18next";

export function CaptainDefaultFallback() {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center p-4 text-sm text-muted-foreground">
      {t("captain.error.displayError")}
    </div>
  );
}
